import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "@app/auth";
import { ReportView } from "./components/report-view/advanced-report.view";
import { AdvancedReportIndexView } from "./components/report-index/report-index.view";
import { AdvancedReportPreview } from "./components/report-preview/advanced-report-preview.view";
import { SubscriptionGuard } from "@app/auth/subscription.guard";

const routes: Routes = [

    // Advanced Reports
    { path: 'org/:orgKey/advanced-reports', component: AdvancedReportIndexView, canActivate: [AuthGuard, SubscriptionGuard] },
    { path: 'org/:orgKey/advanced-reports/:reportKey', component: ReportView, canActivate: [AuthGuard, SubscriptionGuard] },
    { path: 'advanced-reports/preview/:shareKey', component: AdvancedReportPreview },
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class ReportRoutingModule {}
